/**
 * ListLayout.tsx - List Layout for SectionNav
 * 
 * CHANGE HISTORY:
 * - 251115_1806 [current] danielbeer: Created list layout
 */

import React from 'react';
import type { SectionLayoutProps } from '../types';

export const ListLayout: React.FC<SectionLayoutProps> = ({
  sections,
  activeSection,
  onSectionClick
}) => {
  return (
    <div className="section-nav-list" role="list">
      {sections.map((section) => (
        <button
          key={section.id}
          className={`section-list-item ${activeSection === section.id ? 'section-list-item--active' : ''} ${section.disabled ? 'section-list-item--disabled' : ''}`}
          onClick={() => !section.disabled && onSectionClick(section)}
          disabled={section.disabled}
          role="listitem"
          aria-label={section.label}
          aria-pressed={activeSection === section.id}
        >
          {section.icon && (
            <span className="section-list-item__icon" aria-hidden="true">
              {section.icon}
            </span>
          )}
          
          <div className="section-list-item__content">
            <h4 className="section-list-item__label">{section.label}</h4>
            {section.description && (
              <p className="section-list-item__description">{section.description}</p>
            )}
          </div>
          
          {section.badge && (
            <span className="section-list-item__badge" aria-label={`${section.badge} notifications`}>
              {section.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

ListLayout.displayName = 'ListLayout';
